import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import pure from 'recompose/pure';
import Typography from '@material-ui/core/Typography';
import DefaultIcon from '../images/os.png';
// import yandex from 'browser-logos/src/yandex/yandex_256x256.png';

import yandex from 'browser-logos/src/yandex/yandex_256x256.png';
import yandexLite from 'browser-logos/src/yandex-lite/yandex-lite_256x256.png';
import yandexBeta from 'browser-logos/src/yandex-beta/yandex-beta_256x256.png';
import yandexAlpha from 'browser-logos/src/yandex-alpha/yandex-alpha_256x256.png';
import samsungInternet from 'browser-logos/src/samsung-internet/samsung-internet_256x256.png';
import samsungInternetBeta from 'browser-logos/src/samsung-internet-beta/samsung-internet-beta_256x256.png';
import safari from 'browser-logos/src/safari/safari_256x256.png';
import safariTechnologyPreview from 'browser-logos/src/safari-technology-preview/safari-technology-preview_256x256.png';
import safariIos from 'browser-logos/src/safari-ios/safari-ios_256x256.png';
import opera from 'browser-logos/src/opera/opera_256x256.png';
import operaTouch from 'browser-logos/src/opera-touch/opera-touch_256x256.png';
import operaNeon from 'browser-logos/src/opera-neon/opera-neon_256x256.png';
import operaMini from 'browser-logos/src/opera-mini/opera-mini_256x256.png';
import operaMiniBeta from 'browser-logos/src/opera-mini-beta/opera-mini-beta_256x256.png';
import operaDeveloper from 'browser-logos/src/opera-developer/opera-developer_256x256.png';
import operaBeta from 'browser-logos/src/opera-beta/opera-beta_256x256.png';
import firefox from 'browser-logos/src/firefox/firefox_256x256.png';
import firefoxNightly from 'browser-logos/src/firefox-nightly/firefox-nightly_256x256.png';
import firefoxDeveloperEdition from 'browser-logos/src/firefox-developer-edition/firefox-developer-edition_256x256.png';
import firefoxBeta from 'browser-logos/src/firefox-beta/firefox-beta_256x256.png';
import edge from 'browser-logos/src/edge/edge_256x256.png';
import edgeTile from 'browser-logos/src/edge-tile/edge-tile_256x256.png';
import edgeBeta from 'browser-logos/src/edge-beta/edge-beta-1_256x256.png';
import chromium from 'browser-logos/src/chromium/chromium_256x256.png';
import chrome from 'browser-logos/src/chrome/chrome_256x256.png';
import chromeDev from 'browser-logos/src/chrome-dev/chrome-dev_256x256.png';
import chromeCanary from 'browser-logos/src/chrome-canary/chrome-canary_256x256.png';
import chromeBeta from 'browser-logos/src/chrome-beta/chrome-beta_256x256.png';


const sanitizeRestProps = ({
  addLabel,
  allowEmpty,
  basePath,
  cellClassName,
  className,
  formClassName,
  headerClassName,
  label,
  linkType,
  locale,
  record,
  resource,
  sortable,
  sortBy,
  source,
  textAlign,
  translateChoice,
  ...rest
}) => rest;

const BrowserField = ({
  className, source, record = {}, ...rest
}) => {
  // console.log('sdfsdf');
  let icon = DefaultIcon;
  switch (record.browser) {
    case 'Chrome':
      icon = chrome;
      break;
    case 'Chrome Dev':
      icon = chromeDev;
      break;
    case 'Chrome Beta':
      icon = chromeBeta;
      break;
    case 'Chrome Canary':
      icon = chromeCanary;
      break;
    case 'Chromium':
      icon = chromium;
      break;
    case 'Edge':
      icon = edge;
      break;
    case 'Firefox':
      icon = firefox;
      break;
    case 'Opera':
      icon = opera;
      break;
    case 'Opera Mini':
      icon = operaMini;
      break;
    case 'Safari':
      icon = safari;
      break;
    case 'Safari iOS':
      icon = safariIos;
      break;
    case 'Samsung Internet':
      icon = samsungInternet;
      break;
    case 'Yandex Browser':
      icon = yandex;
      break;
    case 'Yandex Browser Lite':
      icon = yandexLite;
      break;
    default:
      icon = DefaultIcon;
      break;
  }
  return (
    <Typography
      component="span"
      body1="body1"
      className={className}
      {...sanitizeRestProps(rest)}
    >
      <img width="14px" height="14px" src={icon} alt={get(record, 'browser')} /> {get(record, source)}
    </Typography>
  );
};

BrowserField.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
  source: PropTypes.string.isRequired,
};

const PureTextField = pure(BrowserField);

PureTextField.defaultProps = {
  addLabel: true,
};

export default PureTextField;



// WEBPACK FOOTER //
// ./src/components/BrowserField.js